// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"FaqSectionComponent_faqSection__eSSbL","gwSectionContainer":"FaqSectionComponent_gwSectionContainer__YQfDl"};